<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <div class="left-right-row row">
                    <div class="left">
                        <form
                            class="form-inline"
                            @submit.prevent="newSearch"
                        >
                            <div class="input-group col-sm-6">
                                <input
                                    v-model.lazy="keyword"
                                    type="search"
                                    class="form-control mb-2 mr-sm-2"
                                    placeholder="Search"
                                    @input="newSearch"
                                >
                            </div>
                            <button class="btn btn-primary mb-2 mr-sm-2">
                                Search
                            </button>
                            <i
                                v-if="loading"
                                class="fa fa-spinner fa-pulse mb-2 mr-sm-2"
                            />
                        </form>
                    </div>
                    <div class="right">
                        <button
                            v-if="view != 'table'"
                            class="btn btn-light"
                            @click="setView('table')"
                        >
                            <i class="fa fa-table" /> List
                        </button>
                        <button
                            v-if="view != 'cards'"
                            class="btn btn-light"
                            @click="setView('cards')"
                        >
                            <i class="fa fa-address-card" /> Cards
                        </button>
                        <router-link
                            :to="{name: routeBase+'.customers.new'}"
                            class="btn btn-success"
                        >
                            <i class="fa fa-plus" /> New Customer
                        </router-link>
                    </div>
                </div>
                <table
                    v-if="customers.length > 0 && view === 'table'"
                    class="table"
                >
                    <thead>
                        <th>
                            Company
                        </th>
                        <th>
                            Billing Contact
                        </th>
                        <th>
                            Email
                        </th>
                        <th>
                            Telephone
                        </th>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(customer) in customers"
                            :key="customer.id"
                        >
                            <td>
                                <router-link :to="{ name: routeBase+'.customers.show', params: { id: customer.id } }">
                                    {{ customer.company_name }}
                                </router-link>
                            </td>
                            <td>
                                <router-link :to="{ name: routeBase+'.customers.show', params: { id: customer.id } }">
                                    {{ customer.billing_name }}
                                </router-link>
                            </td>
                            <td>
                                {{ customer.billing_email }}
                            </td>
                            <td>
                                {{ customer.billing_telephone }}
                            </td>
                            <td class="text-right">
                                <router-link
                                    :to="{ name: routeBase+'.customers.edit', params: { id: customer.id } }"
                                    class="row-icon"
                                >
                                    <i class="fa fa-pencil-alt" />
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div
                    v-if="view === 'cards'"
                    class="customer-card-container"
                >
                    <div class="row">
                        <div
                            v-for="(customer, index) in customers"
                            :key="index"
                            class="col-sm-12 col-md-6"
                        >
                            <div class="card customer-card">
                                <div class="card-body">
                                    <h5>
                                        <router-link :to="{ name: routeBase+'.customers.show', params: { id: customer.id } }">
                                            {{ customer.company_name }}
                                        </router-link>
                                    </h5>
                                    <ul class="customer-items">
                                        <li v-if="customer.account_ref">
                                            <span class="italic">Ref: {{ customer.account_ref }}</span>
                                        </li>
                                        <li v-if="customer.billing_name">
                                            Contact:
                                            <strong>{{ customer.billing_name }}</strong>
                                        </li>
                                        <li v-if="customer.billing_email">
                                            E:
                                            <a
                                                :href="'mailto: ' + customer.billing_email"
                                                title="Email"
                                            >
                                                {{ customer.billing_email }}
                                            </a>
                                        </li>
                                        <li v-if="customer.billing_telephone">
                                            T:
                                            <a
                                                :href="'tel: ' + customer.billing_telephone"
                                                title="Click to call"
                                            >
                                                {{ customer.billing_telephone }}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <i
                    v-if="loading"
                    class="fa fa-spinner fa-pulse mb-2 mr-sm-2"
                />
                <pagination
                    :page="page"
                    :last-page="lastPage"
                    @pageChange="pageChange"
                />
                <span
                    v-if="total > 0"
                    class="pagination-stats"
                >Showing {{ from }} - {{ to }} out of {{ total }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import CustomerService from "../../../services/CustomerService";
import Pagination from "../../PaginationComponent.vue";
import CookieService from "../../../services/CookieService";
import RouterBase from '../../../mixins/RouterBaseMixin';
import NProgress from 'nprogress';
import _ from 'lodash';

export default {
    components: {
        pagination: Pagination
    },
    mixins: [
        RouterBase,
    ],
    data: function() {
        return {
            loading: false,
            customers: [],
            customerService: CustomerService,
            lastPage: 1,
            perPage: 50,
            from: 1,
            to: 1,
            total: 0,
            view: "cards",
        };
    },

    computed: {
        keyword: {
            get() {
                return this.$route.query.keyword || '';
            },
            set(value) {
                this.$router.replace({query: {
                    ...this.$route.query,
                    keyword: value,
                }});
            }
        },
        page: {
            get() {
                return parseInt(this.$route.query.page || '1');
            },
            set(value) {
                this.$router.replace({query: {
                    ...this.$route.query,
                    page: value,
                }});
            }
        },
    },

    watch: {
        $route: {
            immediate: true,
            handler() {
                this.search();
            },
        }
    },

    mounted: function() {
        let view = CookieService.get('customer_view');
        if (view !== null) {
            this.view = view;
        }
    },

    methods: {

        newSearch: _.debounce(function() {
            this.page = 1;
        }, 500),

        search: function() {
            NProgress.start();
            setTimeout(() => {
                this.loading = true;
                let params = {
                    "filter[keyword]": this.keyword,
                    "page[number]": this.page
                };
                this.customerService
                    .search(params)
                    .then(response => {
                        this.customers = response.data.data;
                        this.lastPage = response.data.last_page;
                        this.perPage = response.data.per_page;
                        this.total = response.data.total;
                        this.from = response.data.from;
                        this.to = response.data.to;
                        this.loading = false;
                        NProgress.done();
                        this.updatePages();
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            }, 1000);
        },

        pageChange: function(page) {
            this.page = page;
        },

        setView: function(view) {
            this.view = view;
            CookieService.set('customer_view', view);
        },
    
    
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/customers/SearchComponent.vue